/** @jsx jsx */
import { jsx } from '@emotion/react';
import { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useStore } from 'react-redux';

import { useTranslation } from 'react-i18next';
import { bugsnagNotify, dumpReduxState, getSignUpPath } from '../../util';
import { useBranding } from '../../redux/selectors';

import css from './style.css';
import { hasFeature } from '../../../participant/util/has-feature';
import { getSurveyStatus } from '../../../participant/util/get-survey-status';

const ErrorPage = ({ children, message, image, ...props }) => {
  const { t } = useTranslation();
  const DEFAULT_MESSAGE = t('pages.unknownError');
  const store = useStore();

  useEffect(() => {
    if (message === DEFAULT_MESSAGE && typeof children === 'undefined') {
      const customError = new Error(DEFAULT_MESSAGE);
      const reduxState = dumpReduxState(store.getState());
      bugsnagNotify(customError, { metadata: { props, reduxState } });
    }
  }, []);
  const hasBranding = hasFeature('branding');
  const { errorImage } = useBranding();
  const brandedImage = errorImage ? <img src={errorImage} alt={message} /> : null;

  const showSignupLink =
    !hasFeature('unbranded_org') && ['complete', 'paused'].includes(getSurveyStatus());
  return (
    <div className="row" css={css}>
      <div className="col-md-6">
        <div className="content">
          <h1 className="sorry">{t('pages.sorry')}</h1>
          <div className="text">{children || message}</div>
          {showSignupLink ? (
            <a rel="noopener noreferrer" href={getSignUpPath()} className="signup-survey">
              {t('pages.participantSignUpSurvey')}
            </a>
          ) : null}
        </div>
      </div>
      <div className="col-md-6">
        {hasBranding ? brandedImage : <img src={image} alt={message} />}
      </div>
    </div>
  );
};

ErrorPage.propTypes = {
  image: PropTypes.string,
  children: PropTypes.node,
  message: PropTypes.string,
};

ErrorPage.defaultProps = {
  children: null,
  image: 'https://s3.amazonaws.com/omegarp-assets/images/sorry.jpg',
  message: 'Unknown error',
};

export default ErrorPage;
